import React from "react";
import moment from "moment";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import MovementItem from "../MovementItem/MovementItem";
import { Container, DateSpacer } from "./Styles";

const TRANSACTION_TYPE_ORDER = {
  capital: 0,
  earnings: 1,
  retention: 2,
  earnings_overdue: 3,
  retention_overdue: 4
};

const getTypeOrder = (transactionType) =>
  transactionType in TRANSACTION_TYPE_ORDER
    ? TRANSACTION_TYPE_ORDER[transactionType]
    : Number.MAX_SAFE_INTEGER;

const Movements = ({ items }) => {
  const { t } = useTranslation();

  const sortedTransactions = [...items.transactions].sort((a, b) => {
    if (moment(a.created_at).isSame(b.created_at, "day")) {
      return getTypeOrder(a.transaction_type) - getTypeOrder(b.transaction_type);
    }
    return 0;
  });

  const MovementItems = sortedTransactions.map((item, index) => {
    const Element = [];
    if (
      index === 0 ||
      !moment(item.created_at).isSame(
        sortedTransactions[index - 1].created_at,
        "day"
      )
    ) {
      Element.push(
        <DateSpacer>
          {`${t("myMovements.date")}${moment(item.created_at).format(
            "MMMM D [de] YYYY"
          )}`}
        </DateSpacer>
      );
    }
    Element.push(<MovementItem movement={item} key={item.transaction_id} />);
    return Element;
  });
  return (
    <Container data-testid="container-my-movements">{MovementItems}</Container>
  );
};

Movements.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.string])
  ).isRequired
};

export default Movements;
